<template>
  <div>
    <div class='input-block'>
      <div class='input-label'>Старый пароль</div>
      <p-password v-model='oldPassword' class='p-inputtext-sm password-input' toggleMask :feedback="false" />
    </div>
    <div class='input-block'>
      <div class='input-label'>Новый пароль</div>
      <p-password v-model='newPassword' class='p-inputtext-sm password-input' toggleMask :feedback="false" />
    </div>
    <div class='input-block'>
      <div class='input-label'>Новый пароль еще раз</div>
      <p-password v-model='newPasswordAgain' toggleMask :feedback="false" class='p-inputtext-sm password-input' />
    </div>

    <p-message severity='warn' v-if='newPassMismatch'>
      Пароли не совпадают
    </p-message>

    <div class='btn-block'>
      <p-button label='Отмена' @click='cancel' class='p-button-sm p-button-secondary' />
      <p-button label='Применить' @click='save' class='p-button-sm p-button-success' />
    </div>
  </div>
</template>

<script>
import fetchData from '@/lib/fetchData';

const ROOT_API = process.env.VUE_APP_ROOT_API;
const CHANGE_PASS = ROOT_API + 'auth/change_pass.php';

export default {
  name: 'ChangePass',

  data: () => ({
    oldPassword: '',
    newPassword: '',
    newPasswordAgain: '',
  }),

  computed: {
    newPassMismatch() {
      if (this.newPasswordAgain !== '' && (this.newPasswordAgain !== this.newPassword)) {
        return true;
      }
      return false;
    }
  },

  methods: {
    save() {
      if (this.oldPassword === '' || this.newPassword === '' || this.newPasswordAgain === '') {
        this.$toast.add({severity: 'warn', detail: 'Введены не все данные', life: 10000});
        return;
      }

      if (this.newPassMismatch) {
        this.$toast.add({severity: 'warn', detail: 'Пароли не совпадают', life: 10000});
        return;
      }

      console.log('user_id: ', this.$store.state.auth.userId);
      const form = new FormData();
      form.append('user_id', this.$store.state.auth.userId);
      form.append('old_password', this.oldPassword);
      form.append('new_password', this.newPassword);

      fetchData(CHANGE_PASS, form).then(res => {
        const result = res[0];

        if (result.code !== '0') {
          this.$toast.add({severity: 'warn', detail: result.name, life: 10000});
          return;
        } else {
          this.$toast.add({severity: 'success', detail: result.name, life: 10000});
          this.cancel();
        }
      });
    },

    cancel() {
      this.$emit('cancel');
    },
  }
};
</script>

<style scoped>
.password-input {
  width: 100%;
}

.password-input::v-deep input {
  width: 100%;
}

.input-block {
  margin-bottom: 16px;
}

.input-label {
  margin-bottom: 4px;
}

.btn-block {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>